import { render, staticRenderFns } from "./Gsxx.vue?vue&type=template&id=6619f8bc&scoped=true&"
import script from "./Gsxx.vue?vue&type=script&lang=js&"
export * from "./Gsxx.vue?vue&type=script&lang=js&"
import style0 from "./Gsxx.vue?vue&type=style&index=0&id=6619f8bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6619f8bc",
  null
  
)

export default component.exports